module.exports = __webpack_public_path__ + "images/cdbabylogo.png?b0834";